import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-business-hub-layout',
  standalone: false,
  templateUrl: 'business-hub-layout.html'
})
export class BusinessHubLayout {

  selectedId: string | undefined = "";

  constructor(private router: Router) {}

  ngOnInit() {
    this.selectedId = this.router.url.split('/').pop();
  }

}
